import React, { useEffect } from "react";


export const PickWeek = (props) => {

    const {mode} = props;

    useEffect(()=>{
        if(mode === "TIME") {
            $(".pick-week-area.target ul li a").click(function(){
                $(this).toggleClass("on");
            });
        } else {
            $(".pick-week-area.today ul li a").click(function(){
                $(this).toggleClass("on");
            });
        }
    }, []);

    return (
        <div className={mode === "TIME" ? "pick-week-area target" : "pick-week-area today"}>
            <ul>
                <li><a>일</a></li>
                <li><a>월</a></li>
                <li><a>화</a></li>
                <li><a>수</a></li>
                <li><a>목</a></li>
                <li><a>금</a></li>
                <li><a>토</a></li>
            </ul>
        </div>
    );
};
